export const breadcrumbsReportFromMerchantPart = ({
	id,
	title,
}: {
	id: string | number;
	title: string;
}) => [
	{
		title: "Merchant List",
		link: "/merchant/list",
	},
	{
		title: "Merchant Info",
		link: `/merchant/list/info/${id}/general`,
	},
	{
		title: "U / W Results",
		link: `/merchant/list/info/${id}/results`,
	},
	{
		title,
	},
];
